export default {
  'menu.dashboard': 'დეშბორდი',
  'menu.stats': 'თამაშის სტატისტიკა',
  'menu.players': 'მოთამაშის სტატისტიკა',
  'menu.rounds': 'რაუნდები',
  'menu.promoCampaigns': 'პრომო კამპანიები',
  'menu.promoCampaigns.promoCampaignsCreate': 'კამპანიის შექმნა',
  'menu.promoCampaigns.promoCampaignView': 'კამპანიის ნახვა',
  'menu.operatorSetup': 'ოპერატორის დამატება',
  'menu.report': 'რეპორტი',
  'menu.assistant': 'დიაგნოსტიკის ასისტენტი',
  'menu.settings': 'პარამეტრები',
  'menu.settings.betting': 'ფსონის პარამეტრები',
  'menu.settings.addBetting': 'პარამეტრების დამატება',
  'menu.welcome': 'მოგესალმებით',
  'menu.more-blocks': 'მეტი ბლოკი',
  'menu.home': 'მთავარი',
  'menu.admin': 'ადმინისტრაცია',
  'menu.admin.sub-page': 'ქვე-გვერდი',
  'menu.login': 'შესვლა',
  'menu.register': 'რეგისტრაცია',
  'menu.register-result': 'რეგისტრაციის შედეგი',
  'menu.dashboard.analysis': 'ანალიზი',
  'menu.dashboard.monitor': 'მონიტორინგი',
  'menu.dashboard.workplace': 'სამუშაო ადგილი',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'ფორმა',
  'menu.form.basic-form': 'ძირითადი ფორმა',
  'menu.form.step-form': 'ნაბიჯობრივი ფორმა',
  'menu.form.step-form.info': 'ნაბიჯობრივი ფორმა (შეიყვანეთ გადარიცხვის ინფორმაცია)',
  'menu.form.step-form.confirm': 'ნაბიჯობრივი ფორმა (დაადასტურეთ გადარიცხვის ინფორმაცია)',
  'menu.form.step-form.result': 'ნაბიჯობრივი ფორმა (დასრულებული)',
  'menu.form.advanced-form': 'გაფართოებული ფორმა',
  'menu.list': 'სია',
  'menu.list.table-list': 'ცხრილის ძიება',
  'menu.list.basic-list': 'ძირითადი სია',
  'menu.list.card-list': 'ბარათების სია',
  'menu.list.search-list': 'ძიების სია',
  'menu.list.search-list.articles': 'ძიების სია (სტატიები)',
  'menu.list.search-list.projects': 'ძიების სია (პროექტები)',
  'menu.list.search-list.applications': 'ძიების სია (აპლიკაციები)',
  'menu.profile': 'პროფილი',
  'menu.profile.basic': 'ძირითადი პროფილი',
  'menu.profile.advanced': 'გაფართოებული პროფილი',
  'menu.result': 'შედეგი',
  'menu.result.success': 'წარმატება',
  'menu.result.fail': 'წარუმატებლობა',
  'menu.exception': 'გამონაკლისი',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'ტრიგერი',
  'menu.account': 'ანგარიში',
  'menu.account.center': 'ანგარიშის ცენტრი',
  'menu.account.settings': 'ანგარიშის პარამეტრები',
  'menu.account.trigger': 'შეცდომის გამოწვევა',
  'menu.account.logout': 'გასვლა',
  'menu.editor': 'გრაფიკული რედაქტორი',
  'menu.editor.flow': 'დინების რედაქტორი',
  'menu.editor.mind': 'გონების რუკა',
  'menu.editor.koni': 'კონი რედაქტორი',
};
